import React from 'react';

export const MarkAsUnreadConfirm = (props) => (
  <svg
    fill="none"
    height="24"
    viewBox="0 0 24 24"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.5 4H5C3.89543 4 3 4.89543 3 6V17C3 18.1046 3.89543 19 5 19H19C20.1046 19 21 18.1046 21 17V9.5"
      stroke="black"
      strokeWidth="1.5"
    />
    <path
      d="M20.1616 3.84384L12.3301 13.8271L7.10907 10.1091"
      stroke="black"
      strokeWidth="1.5"
    />
  </svg>
);
